// V4.x — credit packs (display) + unit math. MUST stay identical to the
// server-authoritative copy in supabase/functions/_shared/credits.ts. The
// server validates the price; this file only drives UI labels.

export const UNITS_PER_CREDIT = 60;
export const TTS_UNITS_PER_SECOND = 1;
export const TEXT_UNITS_PER_MESSAGE = 6;
// F2 imagem (provisório até o repricing) — espelho de _shared/credits.ts.
export const IMAGE_UNITS_BASE = 18;
export const IMAGE_UNITS_PRO = 60;

export interface CreditPack {
  id: string;
  amountBrl: number;
  units: number;
  credits: number;
}

export const CREDIT_PACKS: CreditPack[] = [
  { id: "pack_20", amountBrl: 20, units: 600, credits: 10 },
  { id: "pack_50", amountBrl: 50, units: 1680, credits: 28 },
  { id: "pack_100", amountBrl: 100, units: 3600, credits: 60 },
];

// RC StoreKit product id → VYV credits granted. DISPLAY ONLY — the server
// (revenuecat-webhook → grant_credits_atomic) is authoritative on the grant.
// Keep in sync with CREDIT_PACKS above and supabase/functions/_shared/credits.ts.
export const CREDITS_BY_PRODUCT_ID: Record<string, number> = {
  vyv_credits_20: 10,
  vyv_credits_50: 28,
  vyv_credits_100: 60,
};

// Credits granted by a StoreKit product id, or null when unknown (defensive —
// the sheet then shows the price only rather than a wrong credit amount).
export function creditsForProductId(productId: string): number | null {
  return CREDITS_BY_PRODUCT_ID[productId] ?? null;
}

// Display conversions from a unit balance.
export function unitsToCredits(units: number): number {
  return Math.floor(units / UNITS_PER_CREDIT);
}
export function unitsToVoiceMinutes(units: number): number {
  // 1 unit = 1 second of TTS.
  return Math.floor(units / TTS_UNITS_PER_SECOND / 60);
}
export function unitsToTextMessages(units: number): number {
  return Math.floor(units / TEXT_UNITS_PER_MESSAGE);
}

const BRL = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });
export function formatBRL(value: number): string {
  return BRL.format(value);
}
